import { Component, Input } from '@angular/core';

@Component({
  selector: 'frodo-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  @Input() text: string;
}
